export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';

export const APP_VERSION = process.env.APP_VERSION;

const BASE_API = process.env.LOCAL_BACKEND || process.env.LOCAL_HOST || 'localhost'; // 192.168.31.226 || 172.31.176.1
const BASE_NAME = process.env.BASE_NAME || 'schoolinked';
const BASE_PROD_NAME = process.env.PROD_NAME_ENV || "production";

export const DEVELOPMENT_LOCAL_API_URL = 'http://localhost:8080/api/';
export const DEVELOPMENT_LOCAL_APP_API_URL = `http://${BASE_API.toString()}:8080/api/`;

const getProdSite = (nameEnv) => {
  if (nameEnv?.indexOf('arbaz') >= 0 ) {
    return `http://arbaz.schoolinked.show`;
  } else if (nameEnv?.indexOf('co-herens') >= 0) {
    return `http://co-herens.schoolinked.show`;
  } else {
    return 'https://schoolinked-demo.tcf-dev.com';
  }
}

export const DEVELOPMENT_API_URL = `https://${BASE_NAME}-dev.herokuapp.com/api/`;
export const STAGING_API_URL = `https://${BASE_NAME}.herokuapp.com/api/`;
export const PRODUCTION_API_URL = `https://${BASE_NAME}-app.herokuapp.com/api/`;

export const PRODUCTION_API_URL_SCHOOLS = `https://${BASE_PROD_NAME}.herokuapp.com/api/`;
export const PRODUCTION_SITE = getProdSite(BASE_PROD_NAME);

export const PROXY_API_URL = 'https://tcf-reverse-proxy.herokuapp.com/';

export const STORAGE_BUCKET_URL = `https://storage.googleapis.com/${BASE_NAME}-dev`;
